import script from "./ModalAddressForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAddressForm.vue?vue&type=script&setup=true&lang=js"

import "./ModalAddressForm.vue?vue&type=style&index=0&id=071058a4&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071058a4"]])

export default __exports__